<!-- 被盗找回（功能入口已关闭） -->
<template>
  <div :class="$style.wrap">
    <!-- 协议提示/协议内容 -->
    <template v-if="active == 0">
      <template v-if="attentionText.length > 0">
        <h3 class="title_wrap">注意事项</h3>
        <div class="tip_wrap">
          <div v-html="attentionText"></div>
        </div>
        <van-button
          :class="$style.agree"
          round
          type="primary"
          size="large"
          tag="input"
          value="同意协议并申请找回"
          native-type="submit"
          @click.stop.prevent="onSubmit"
        />
        <p :class="$style.agreement" @click="handlerShow">
          被盗虚拟物品申请找回服务协议
        </p>
        <!-- 服务协议 -->
        <the-agreement
          :show="isShow"
          @handlerShow="handlerShow"
          :agreementHtml="agreementHtml"
        />
      </template>
    </template>
    <!-- 同意协议-->
    <template v-else>
      <div class="tip_wrap">
        <tipIcon iconName="Tel" />
        <div>
          <p>请使用您的绑定手机{{ sLoginCode }}</p>
          <p>
            拨打客服电话
            <span>{{ phone }}</span
            >提交申请
          </p>
        </div>
      </div>
      <van-button
        round
        :class="$style.call"
        type="primary"
        size="large"
        tag="input"
        value="直接通过本机拔打"
        native-type="submit"
        @click.stop.prevent="onPhone"
      />
    </template>
  </div>
</template>
<script>
import { minxinActive } from "@/mixins/minxinActive";
import { mapActions, mapGetters } from "vuex";
import { isBindPhone, contentInit } from "@/http/serve";
import tipIcon from "../components/TipIcon";
import TheAgreement from "@/components/TheAgreement";
export default {
  name: "back",
  mixins: [minxinActive],
  data() {
    return {
      phone: "0592-3371910",
      agreementHtml: "", //协议字符
      attentionText: "", //协议内容
      isShow: false, //是否展示协议
      sLoginCode: "" //手机号
    };
  },
  components: {
    tipIcon,
    TheAgreement
  },
  mounted() {
    this.SetLeave(false);
    this.getWebContent();
  },
  computed: {
    ...mapGetters(["gameId"])
  },
  methods: {
    ...mapActions(["SetGame", "SetLeave"]),
    /**
     * @description 提交
     */
    onSubmit() {
      this.isBindePhone();
    },
    /**
     * @description 是否绑定手机
     */
    async isBindePhone() {
      let res = await isBindPhone();
      let { rcode, data } = res;
      if (rcode == 5003) {
        this.$Dialog
          .confirm({
            title: "您还未绑定手机，暂无法申请被盗找回。",
            message: "是否去绑定手机号？",
            confirmButtonText: "立即绑定",
            cancelButtonText: "我知道了"
          })
          .then(() => {
            this.$router.replace({
              path: this._anchor.verifier.path
            });
          })
          .catch(() => {});
        return false;
      }
      if (rcode != 0) return;
      this.setActive();
      this.sLoginCode = data.s_login_code;
    },
    /**
     * @description 获取网页协议内容
     */
    async getWebContent() {
      let parmas = {
        game_id: this.gameId,
        content_type: "announcements"
      };

      let res = await contentInit(parmas);
      let { rcode, data } = res;
      if (rcode != 0) return;
      let { announcements, agreement } = data;
      this.attentionText = announcements;
      this.agreementHtml = agreement;
    },
    /**
     * @description 展示协议
     */
    handlerShow() {
      this.isShow = !this.isShow;
    },
    /**
     * @description 拨打电话
     */
    onPhone() {
      window.location.href = "tel:" + this.phone;
    },
    /**
     * @description 页面步骤回退
     */
    goBack() {
      if (this.active === 1) {
        this.getWebContent();
        this.backActive();
        return false;
      }
      return true;
    },
    /**
     * @description 移除所有
     */
    removeAll() {
      this.$ls.set("active", 0);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding: 1.68rem 0.47rem 0rem 0.47rem;
  .flex-center;
  .flex-col;
  .agreement {
    font-size: 0.25rem;
    color: #1b8cff;
    text-decoration: underline;
    margin-top: 0.4rem;
  }

  .call {
    margin-top: 0.79rem;
  }
  .agree {
    margin-top: 0.74rem;
  }
}
</style>
